
  import { Vue, Component, Prop } from "vue-property-decorator";

  import GET_USER_PROFILE from "@/apollo/profile/GetUserProfile.gql";

  import PageHeadContainer from "@/components/page/PageHeadContainer.vue";
  import PageHeadIcon from "@/components/page/PageHeadIcon.vue";
  import BadgeIcon from "@/components/icons/BadgeIcon.vue";
  import ClockIcon from "@/components/icons/ClockIcon.vue";
  import ProfileBasic from "@/components/profile/ProfileBasic.vue";
  import AdditionalData from "@/components/profile/ManagerAdditionalData.vue";
  import LoadingOverlay from "@/components/common/LoadingOverlay.vue";

  import { User } from "@/interface";

  @Component({
    components: {
      PageHeadContainer,
      PageHeadIcon,
      BadgeIcon,
      ClockIcon,
      AdditionalData,
      ProfileBasic,
      LoadingOverlay,
    },
    apollo: {
      currentUserInfo: {
        query: GET_USER_PROFILE,
        variables() {
          return {
            id: this.userId,
          };
        },
        update: (data) => {
          return data.user_by_pk;
        },
      },
    },
  })
  export default class ManagerProfile extends Vue {
    @Prop({ type: String, required: true }) readonly userId!: string;

    currentUserInfo?: User = undefined;

    get title(): string {
      if (!this.currentUserInfo) {
        return "n/a";
      }

      const { given_name, family_name } = this.currentUserInfo;
      return `${given_name} ${family_name}`;
    }

    get updatedAt(): string {
      return `last modified ${this.$moment(String(this.currentUserInfo?.updated_at))
        .format("hh:mmA, MMMM DD, YYYY")}`;
    }

    get iconClasses(): string {
      return "mr-1 h-5 w-5 text-gray-400 group-hover:text-gray-500 group-focus:text-gray-500";
    }

    updateDate(): void {
      this.currentUserInfo!.updated_at = new Date().toISOString();
    }
  }
